import { Action, createReducer, on } from "@ngrx/store";

import * as ApplicationActions from "../application.actions";
import {
  ApplicationFeatureState,
  DEFAULT_APPLICATION_STATE,
} from "../application.state";

import { ApplicationReducerMapperService } from "./mapper/application-reducer-mapper.service";

const reducer = createReducer(
  DEFAULT_APPLICATION_STATE,
  ///////////////////////////////////////////////////////////////////////////////
  // Business Actions
  ///////////////////////////////////////////////////////////////////////////////

  on(ApplicationActions.createApplication, (state, _) => ({
    ...state,
    isBusy: true,
  })),

  ///////////////////////////////////////////////////////////////////////////////
  // Chain Reaction Actions
  ///////////////////////////////////////////////////////////////////////////////

  // CREATE
  on(ApplicationActions.createApplicationStart, (state) => ({
    ...state,
    error: undefined,
    isBusy: true,
  })),

  on(ApplicationActions.createApplicationSuccess, (state, payload) =>
    ApplicationReducerMapperService.mapSuccessResponseToState(state, payload),
  ),

  on(ApplicationActions.createApplicationFail, (state, payload) => ({
    ...state,
    error: payload.error,
    isBusy: false,
  })),

  // GET
  on(ApplicationActions.getApplicationStart, (state) => ({
    ...state,
    error: undefined,
    isBusy: true,
  })),

  on(ApplicationActions.getApplicationSuccess, (state, payload) =>
    ApplicationReducerMapperService.mapSuccessResponseToState(state, payload),
  ),

  on(ApplicationActions.getApplicationFail, (state, payload) => ({
    ...state,
    error: payload.error,
    isBusy: false,
  })),

  // Reset Errors
  on(ApplicationActions.resetApplicationError, (state) => ({
    ...state,
    error: undefined,
  })),
);

export function featureReducer(
  state: ApplicationFeatureState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
